export default __webpack_public_path__ + "static/media/no-promotions-img.61bb3f76.svg";